exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "code[data-v-0c972e18]{font-size:.8rem}", ""]);

// exports
